const mockIP = [
  {
    id: 1,
    img: "accesories/AirTag.jpg",
    model: "AirTag",
  },
  {
    id: 2,
    img: "accesories/AirPods.jpg",
    model: "AirPods",
  },
  {
    id: 3,
    img: "accesories/Cargador.jpg",
    model: "Cargadores",
  }
];

export default mockIP;
